import React, {memo} from 'react';
import {
  Box,
  OutlinedInput,
  Radio,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TableHead,
  Typography,
} from '@mui/material';
import {
  SentimentVeryDissatisfied,
  SentimentDissatisfied,
  SentimentSatisfied,
  SentimentSatisfiedAlt,
  SentimentVerySatisfied,
} from '@mui/icons-material';

import {IOption} from 'shared/services/api/quiz/Quiz';

interface IGridUniqueAnswerPreviewProps {
  columnOptions: IOption[];
  rowOptions: IOption[];
  hasComment?: boolean;
}

const optionsEmoji = [
  <SentimentVeryDissatisfied color="primary" fontSize="large" />,
  <SentimentDissatisfied color="primary" fontSize="large" />,
  <SentimentSatisfied color="primary" fontSize="large" />,
  <SentimentSatisfiedAlt color="primary" fontSize="large" />,
  <SentimentVerySatisfied color="primary" fontSize="large" />,
];

export const GridUniqueAnswerPreview: React.FC<IGridUniqueAnswerPreviewProps> =
  memo(({columnOptions, rowOptions, hasComment = false}) => {
    return (
      <Box component="div" overflow="auto" minWidth={600}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell />

              {columnOptions.map((column) => {
                return (
                  <TableCell
                    key={column.order}
                    align="center"
                    style={{
                      background: !column.iconOrColor
                        ? '#fafafa'
                        : column.iconOrColor,
                      color:
                        columnOptions.length <= 5
                          ? 'black'
                          : !column.iconOrColor
                          ? 'black'
                          : 'white',
                    }}>
                    <Box maxWidth={150}>
                      <Typography style={{wordWrap: 'break-word'}}>
                        {column.description || 'Opção ' + column.order}
                      </Typography>
                    </Box>
                    {/* emoji */}
                    {columnOptions.length <= 5 &&
                      Number.isInteger(
                        Number.parseInt(column.iconOrColor ?? ''),
                      ) &&
                      optionsEmoji[Number.parseInt(column.iconOrColor ?? '')]}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {rowOptions.map((line) => {
              return (
                <TableRow key={`GridUniqueAnswer-Preview-Line-${line.order}`}>
                  <TableCell style={{color: 'black'}}>
                    <Box maxWidth={250}>
                      <Typography style={{wordWrap: 'break-word'}}>
                        {line.description || 'Opção ' + line.order}
                      </Typography>
                    </Box>
                  </TableCell>
                  {columnOptions.map((column) => {
                    return (
                      <TableCell
                        key={`${line.order}-${column.order}`}
                        align="center">
                        <Radio checked={false} disabled />
                      </TableCell>
                    );
                  })}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>

        {hasComment && (
          <Box maxWidth={400} marginTop={3}>
            <OutlinedInput fullWidth disabled placeholder="Comentar" />
          </Box>
        )}
      </Box>
    );
  });
